import React, { useEffect, useState } from 'react';

const InstagramEmbedPermalink = ({ url, width = "320px", height = "440px" }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadInstagramScript = () => {
      // Check if the script already exists in the document.
      if (!document.querySelector('script[src="https://www.instagram.com/embed.js"]')) {
        const script = document.createElement("script");
        script.src = "https://www.instagram.com/embed.js";
        script.async = true;
        script.onload = () => {
          if (window.instgrm &&
              window.instgrm.Embeds &&
              typeof window.instgrm.Embeds.process === "function") {
            window.instgrm.Embeds.process();
          }
          setIsLoading(false);
        };
        document.body.appendChild(script);
      } else {
        // If the script tag is present, wait for a short delay to ensure it's loaded
        // then process the embeds.
        setTimeout(() => {
          if (window.instgrm &&
              window.instgrm.Embeds &&
              typeof window.instgrm.Embeds.process === "function") {
            window.instgrm.Embeds.process();
          }
          setIsLoading(false);
        }, 0);
      }
    };

    // If Instagram embed object exists, process immediately.
    if (window.instgrm && window.instgrm.Embeds) {
      window.instgrm.Embeds.process();
      setIsLoading(false);
    } else {
      loadInstagramScript();
    }
  }, [url]);

  return (
    <>
      <blockquote
        className="instagram-media"
        data-instgrm-permalink={url}
        data-instgrm-version="14"
        style={{ margin: 'none', 

          
        }}
      />

    <style>
        {`
          .instagram-media {
            
            border: none !important;
            box-shadow: none !important;
          }
          .instagram-media iframe {
            border: none !important;
          }
        `}
      </style>
    </>
  );
};

export default InstagramEmbedPermalink;
